import styled from '@emotion/styled';
import { t } from 'i18next';

import { EmptyClassroomShadow } from '@innovamat/glimmer-assets';
import { Typography } from '@innovamat/glimmer-components';

import type { ClassroomType } from '../../modules/classroom';
import { CLASSROOM_TYPE, isJourneyType } from '../../modules/classroom';

type Props = {
  goToJoinClassroomsButton: JSX.Element;
  classroomType: ClassroomType;
};

const ErrorWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    padding-bottom: 16px;
  }
`;

const RightSideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    align-items: center;
  }
`;

const ErrorTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: flex-start;
  align-items: flex-start;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    text-align: center;
    align-items: center;
  }
`;

const ErrorTextSubtitle = styled(Typography.Body2)`
  color: ${({ theme }) =>
    theme.tokens.color.alias.cm.text['text-subtle'].value};
  max-width: 400px;
`;

export function NoClassesEmptyState({
  goToJoinClassroomsButton,
  classroomType = CLASSROOM_TYPE.CLASSROOM,
}: Props): JSX.Element {
  const isJourney = isJourneyType(classroomType);

  return (
    <ErrorWrapper>
      <EmptyClassroomShadow />
      <RightSideWrapper>
        <ErrorTextWrapper>
          <Typography.H4>
            {isJourney
              ? t('my-classes.no-journeys.description')
              : t('my-classes.no-classes.description')}
          </Typography.H4>
          <ErrorTextSubtitle>
            {isJourney
              ? t('my-classes.no-journeys.title')
              : t('my-classes.no-classes.title')}
          </ErrorTextSubtitle>
        </ErrorTextWrapper>
        {goToJoinClassroomsButton}
      </RightSideWrapper>
    </ErrorWrapper>
  );
}
